import {
  Subscription,
  SubscriptionOnboardingTypeEnum,
  SubscriptionStatusEnum,
} from "@rentablo/api/apiv1";

type SubscriptionStatus = SubscriptionStatusEnum | "processing_at_bank_reduced";

export const calculateCurrentCashbackStatus = (
  subscriptions: Subscription[]
): SubscriptionStatus => {
  let currentStatus: SubscriptionStatus = "processed";

  for (const subscription of subscriptions) {
    if (subscription.status === "contract_terminated") {
      currentStatus = "contract_terminated";
      continue;
    }
    if (
      subscription.status === "in_progress" &&
      subscription.onboardingType !== SubscriptionOnboardingTypeEnum.EXTERNAL
    ) {
      currentStatus = subscription.status;
      continue;
    }

    if (
      subscription.status === "incomplete" &&
      currentStatus !== "in_progress"
    ) {
      currentStatus = subscription.status;
      continue;
    }

    if (
      subscription.status === "internal_processing" &&
      currentStatus !== "incomplete" &&
      currentStatus !== "in_progress"
    ) {
      currentStatus = subscription.status;
      continue;
    }

    if (
      subscription.status === "processing_at_bank" &&
      currentStatus !== "in_progress" &&
      currentStatus !== "incomplete" &&
      currentStatus !== "internal_processing"
    ) {
      currentStatus = subscription.status;
      continue;
    }

    if (
      subscription.status === "in_progress" &&
      currentStatus !== "in_progress" &&
      currentStatus !== "incomplete" &&
      currentStatus !== "internal_processing" &&
      subscription.onboardingType === SubscriptionOnboardingTypeEnum.EXTERNAL
    ) {
      currentStatus = "processing_at_bank_reduced";
    }
  }

  return currentStatus;
};
